import {
  fullWidthContainer,
  maxWidthContainer,
} from "../CourseContent/styles/constants";
import {
  DEFAULT_HIGHLIGHTS_TITLE,
  DEFAULT_HIGHLIGHTS_ITEMS,
} from "./constants";
import HighlightsPromo, { HighlightsPromoProps } from "./HighlightsPromo";
import HighlightsItem, { HighlightItem } from "./HighlightsItem";
import SkillsList from "../CourseContent/ContentRefresh/SkillsList";
import { cn } from "@/lib/utils";
import useTranslations from "@/i18n/useTranslations";

type HighlightsProps = {
  title?: string;
  items?: HighlightItem[];
  partnerName?: string;
  promo?: HighlightsPromoProps;
  isEnrollable?: boolean;
  theme?: "light" | "dark";
  className?: string;
  showSkillsList?: boolean;
  associatedSkills?: string[];
  containerClassName?: string;
  highlightsContainerClassName?: string;
};

export default function Highlights({
  title = DEFAULT_HIGHLIGHTS_TITLE,
  items = DEFAULT_HIGHLIGHTS_ITEMS,
  partnerName,
  promo,
  isEnrollable = false,
  theme = "light",
  className,
  showSkillsList = false,
  associatedSkills = [],
  containerClassName,
  highlightsContainerClassName,
}: HighlightsProps) {
  const t = useTranslations("Course");
  const displayItems = items.slice(0, 3);

  return (
    <div
      className={cn(className)}
      style={{
        maxWidth: "none",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
      }}
    >
      <div className={`${maxWidthContainer} ${fullWidthContainer} max-xl:px-4`}>
        <div
          className={cn("pt-8 md:pt-16 pb-8 bg-putty-300", containerClassName)}
        >
          <h2 className="font-bold md:text-3xl text-2xl text-elm-500 text-center mt-0">
            {title}
          </h2>

          <div className="flex flex-col md:flex-row gap-8 w-full">
            {displayItems.map((item, index) => (
              <div
                key={index}
                className={cn(
                  "bg-putty-100 rounded-xl p-8 flex-1",
                  highlightsContainerClassName,
                )}
              >
                <HighlightsItem {...item} partnerName={partnerName || ""} />
              </div>
            ))}
          </div>

          {!promo && showSkillsList && associatedSkills.length > 0 && (
            <div className="mt-8">
              <SkillsList
                associatedSkills={associatedSkills}
                title={t("growTheseSkills")}
                theme={theme}
              />
            </div>
          )}
        </div>

        {isEnrollable && promo && (
          <HighlightsPromo
            headline={promo.headline}
            subtext={promo.subtext}
            infoText={promo.infoText}
            ctaElement={promo.ctaElement}
            headlineMobile={promo.headlineMobile}
            subtextMobile={promo.subtextMobile}
          />
        )}
      </div>
    </div>
  );
}
